/* eslint-disable max-len */
// Text constants for ProjectsNullView component
const nullStateConstants = {
  cardTitle: 'Keep Jobs Organized.\nFrom Start to Finish.',
  bodyText: 'Plan materials, costs, and purchases across the lifecycle of every project. Collaborate with your team and stay on track.',
  imageAlt: 'Projects placeholder image',
  buttonText: 'Create New Project',
  buttonTextDesktop: 'Create New',
  imageUrl: 'https://dam.thdstatic.com/content/production/KbWDdt37lP7rjFsZAZdYow/kgZwp_KtZ9nSQVLCQIy3Mg/downloadImageForWeb/006_2025_ProProjects_ProsOnTech_04-1985_L.Jpg',
  learnMoreText: 'Learn More',
  learnMoreLink: '/c/create-a-project',
};

export default nullStateConstants;
